import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import { useMemo } from "react";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import ConfigurationService from "../../../services/configuration-service.js";
import {
  initialFormData,
  initialErrors,
  fieldValidation,
  transactionSerachFormData,
} from "../../common/helper/form-constants.js";
import { commissionColoumns } from "./commisions-col-component.js";
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import TransactionSearchFilter from "./../../common/helper/transactionSearchFilter.js";
import SearchFilter from "./../../common/helper/searchFilter.js";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import useIsMobile from "../../common/hooks/useIsMobile.js";
import {
  paymentMethods,
  transactionStatus,
  transactionType,
} from "../../common/helper/status-constant.js";

const Commissions = () => {
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [commissionData, setCommssionData] = useState([]);
  const [filterApplied, setFilterApplied] = useState(true);
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const navigate = useNavigate();
  const userData = useSelector((state) => state.authReducer);
  const [searchTerm, setSearchTerm] = useState("");
  const [role, setUserRole] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [formData, setFormData] = useState({ ...transactionSerachFormData, from_date: '', to_date: '' });
  const [totalRows, setTotalRows] = useState("");
  const [filterData, setFilterData] = useState({
    end_date: "",
    start_date: "",
    customer_id: "",
    agent_id: "",
    payment_method: "",
  });
  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  const [columns, setColumns] = useState(commissionColoumns());

  const handleRowsPerPageChange = (value) => {
    let rowsPage = Number(value);
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
    listCommissions(false, pageNo, rowsPage, filterData);
  };

  const listCommissions = (
    fiterReset = false,
    pageNumber,
    rowsPage,
    filterData
  ) => {
    setLoading(true);

    ConfigurationService.getCommissions(
      fiterReset ? {} : filterData,
      pageNumber,
      rowsPage
    )
      .then((response) => {
        const records = response.data.data.list;
        setTotalRows(response.data.data.total_records);

        setCommssionData(records);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
  };
  const downloadTransaction = () => {
    // if (new Date(formData.from_date) > new Date(formData.to_date)) {
    //   toast.error("From Date should not be greater than to Date");
    //   return;
    // }
    // let hasErrors = false;
    // let requiredFields = [
    //   "merchant_order_code",
    //   "agent_email",
    //   "agent_mobile",
    //   "agent_code",
    // ];
    // requiredFields.forEach((fieldName) => {
    //   const error = validateField(fieldName, formData[fieldName]);
    //   if (error) {
    //     hasErrors = true;
    //   }
    // });
    // if (!hasErrors) {
    let userRole = "";
    let transaction = ConfigurationService.downloadCommssions(
      filterData,
      pageNo,
      rowsPerPage
    );
    setLoading(true);
    transaction
      .then((response) => {
        const blob = new Blob([response.data], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "commsions.csv"); // Specify the file name here
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
        toast.success("Commsions downloaded successfully.");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        try {
          const errorMessage = error.response.data;
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        } catch (e) {
          toast.error(MESSAGES.SERVER_ERROR);
        }
      });
    // }
  };
  const applyFilter = (data) => {
    setFilterData(data);
    setFormData(data);
    listCommissions(false, pageNo, rowsPerPage, data);
    setFilterApplied(true);
    setIsOpenDrawer(false);
  };

  const handleRemoveAppliedFilter = (fieldName) => {
    const updated = { ...formData, [fieldName]: "" };
    setFormData(updated);
    setFilterData(updated);
    listCommissions(false, pageNo, rowsPerPage, updated);
  };

  const selectedFilter = useMemo(() => {
    return Object.entries(formData).map((item) => {
      let keyName = item[0]
        .split("_")
        .map((w) => w.slice(0, 1).toLocaleUpperCase() + w.slice(1))
        .join(" ");
      let dataValues = item[1];
      if (keyName === "Distributor Id") {
        const found = distributors.find((d) => d.value == dataValues);
        dataValues = found ? found.name : dataValues;
      } else if (keyName === "Customer Id") {
        const found = merchants.find((m) => m.value == dataValues);
        dataValues = found ? found.name : dataValues;
      } else if (keyName === "Agent Id") {
        const found = agents.find((a) => a.value == dataValues);
        dataValues = found ? found.name : dataValues;
      } else if (keyName === "Payment Method") {
        const found = paymentMethods.find((p) => p.value == dataValues);
        dataValues = found ? found.label : dataValues;
      } else if (keyName === "Status") {
        const found = transactionStatus.find((s) => s.value == dataValues);
        dataValues = found ? found.label : dataValues;
      } else if (keyName === "Transaction Type") {
        const found = transactionType.find((t) => t.value == dataValues);
        dataValues = found ? found.label : dataValues;
      }
      if (dataValues)
        return (
          <div
            key={item[0]}
            className={`${isMobile ? "d-inline-block" : "d-flex"} px-3 py-1 mx-2 my-2`}
            style={{
              border: "2px solid rgb(145 202 207 / 77%)",
              borderRadius: "50px",
              color: "#495a69",
            }}
          >
            <span style={{ fontWeight: 700, fontSize: "14px" }}>
              {keyName.replace(/Id/i, "").trim()}
            </span>{" "}
            : <span style={{ fontSize: "14px" }}>{dataValues}</span>{" "}
            <span
              className="ms-2"
              style={{ cursor: "pointer" }}
              onClick={() => handleRemoveAppliedFilter(item[0])}
            >
              <CloseIcon sx={{ fontSize: "17px" }} />
            </span>
          </div>
        );
    });
  }, [formData, agents, merchants, distributors]);

  useEffect(() => {
    if (userData && userData.user && userData.user.data) {
      const userRole = userData.user.data.role.role_code;
      console.log(userRole);
      setUserRole(userRole);
      const updatedColumns = [
        ...columns.slice(0, 4), // Keep the first 4 columns unchanged
        // Add new columns here

        ...(userRole == "ADMIN" || userRole == "OSUBADMIN"
          ? [
              {
                name: "Distributor",
                selector: (row) => row.distributor_name || "-",
                sortable: true,
              },
              {
                name: "Agent Commission",
                selector: (row) => "₹" + row.agent_commission,
                sortable: true,
              },
              {
                name: "Merchant Commission",
                selector: (row) => "₹" + row.merchant_commission,
                sortable: true,
              },
              {
                name: "Distributor Commission",
                selector: (row) =>
                  row.distributor_commission
                    ? "₹" + row.distributor_commission
                    : "₹0",
                sortable: true,
              },
            ]
          : [
              {
                name: "Commission",
                selector: (row) =>
                  userRole === "DADMIN"
                    ? `₹${row.distributor_commission}`
                    : userRole === "AGENT"
                    ? `₹${row.agent_commission}`
                    : `₹${row.merchant_commission}`,
                sortable: true,
              },
            ]),
        ...columns.slice(4),
      ];
      setColumns(updatedColumns);
      listCommissions(false, 0, 10, filterData);
    }

    document.body.style.backgroundImage = "";

    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, []);

  const handlePageChange = (page) => {
    let pageNumber = page - 1;
    setPageNo(pageNumber);
    listCommissions(false, pageNumber, rowsPerPage, filterData);
  };

  useEffect(() => {
    if (commissionData?.length) {
      const element = document.getElementsByClassName("sc-bHCmUC");
      const childElement = element[0].children;
      for (let i = 0; i < childElement?.length; i++) {
        const ele = childElement[i].id.split("-")[1];
        if (Number(ele) % 2 === 0) {
          childElement[i].classList.add("even-transaction-table");
        } else {
          childElement[i].classList.add("odd-transaction-table");
        }
      }
    }
  }, [commissionData]);

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div className="container-fluid px-4" style={{ paddingBottom: "30px" }}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Commsions
          </h4>
          <div>
            <div>
              <MUIButton
                btnOnClick={() => setIsOpenDrawer((prev) => !prev)}
                btnLabel="Filter"
                btnStyle={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: "rgb(117 121 124 / 82%)",
                  },
                }}
              >
                <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />{" "}
              </MUIButton>
            </div>
          </div>
        </div>
        <div className="container" style={{ backgroundColor: "white" }}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link tbbtn active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected="true"
              >
                Commission List
              </button>
            </div>
            <div className="d-flex mt-3" style={{ float: "right" }}>
              <div
                className="me-3"
                onClick={() => downloadTransaction("fetchTransaction")}
              >
                <DownloadForOfflineIcon sx={{ fontSize: "35px" }} />
              </div>
            </div>
          </nav>

          <RowsPerPageSelector
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
          />

          <div>
            {isMobile && isOpenDrawer && (
              <SearchFilter
                isOpenDrawer={isOpenDrawer}
                setIsOpenDrawer={setIsOpenDrawer}
                fetchTransaction={(data) => applyFilter(data)}
                formData={formData}
                setFormData={setFormData}
                module="Commission"
                isTransactionFilter={false}
                setAgentsData={setAgents}
                setMerchantsData={setMerchants}
                setDistributorsData={setDistributors}
              />
            )}
            {isOpenDrawer && !isMobile && (
              <div
                className="container my-4"
                style={{ border: "1px solid #80808063", borderRadius: "15px" }}
              >
                <TransactionSearchFilter
                  isOpenDrawer={isOpenDrawer}
                  setIsOpenDrawer={setIsOpenDrawer}
                  fetchTransaction={(data) => applyFilter(data)}
                  formData={formData}
                  setFormData={setFormData}
                  module="Commission"
                  isTransactionFilter={false}
                  setAgentsData={setAgents}
                  setMerchantsData={setMerchants}
                  setDistributorsData={setDistributors}
                />
              </div>
            )}
          </div>

          <div
            className="tab-content"
            id="nav-tabContent"
            style={{ paddingTop: "15px", paddingBottom: "15px" }}
          >
            <div
              className="tab-pane fade active show"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div
                style={
                  isMobile
                    ? { display: "flex", height: "50px", overflow: "scroll", width: "max-content" }
                    : { display: "flex", flexWrap: "wrap" }
                }
              >
                {filterApplied && !isOpenDrawer && selectedFilter}
              </div>
              <div
                id="examplemgmwallet_wrapper"
                className="dataTables_wrapper dt-jqueryui no-footer"
              >
                <div
                  style={{
                    height: isOpenDrawer ? "425px" : "auto",
                    overflowY: isOpenDrawer ? "auto" : "visible",
                  }}
                >
                  <DataTable
                    key={dataTableKey}
                    columns={columns}
                    data={commissionData}
                    pagination
                    paginationPerPage={rowsPerPage}
                    paginationComponentOptions={paginationComponentOptions}
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    customStyles={customDataTableStyles}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(Commissions));
